import { currencies } from '@/shared/constants/currencies';

export function formatCurrency(num: number, currency: string, separator = ' ') {
  if (!currency) currency = 'EUR';
  const currencyObject = currencies[currency];
  if (!num) return '';
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + separator) + ' ' + currencyObject.symbol;
}
